// extracted by mini-css-extract-plugin
module.exports = {"form":"Application_form__1k_Ya","Submit":"Application_Submit__1n1nW"};